// extracted by mini-css-extract-plugin
export default {"textarea":"textarea__8N7-V","textareaDefault":"textareaDefault__wpSuw"};